import React from 'react';
import { FormattedMessage } from 'react-intl';

export default (props) => {
  const copy = <FormattedMessage
    id="pbgUserAgreement.text"
    defaultMessage="Key Travel User Agreement"
  />;

  return (
    <a
      href="https://www.paybygroup.com/user-agreement/"
      target="_blank"
      rel="noopener noreferrer"
      className={props.className}
    >
      {props.text || copy}
    </a>
  );
};



// WEBPACK FOOTER //
// ./src/desktop/components/pbg-user-agreement.js